import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgbTypeaheadSelectItemEvent } from "@ng-bootstrap/ng-bootstrap";
import { merge, Observable, OperatorFunction, Subject } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";
import { AppConstants } from "src/app/constants/app.constants";

@Component({
  selector: "app-input-selector-with-search",
  templateUrl: "./input-selector-with-search.component.html",
  styleUrls: ["./input-selector-with-search.component.scss"],
})
export class InputSelectorWithSearchComponent implements OnInit {
  @Input() list;
  @Input() fields = [];
  @Input() id;
  @Input() item: any;
  @Input() active: boolean | undefined;

  @Output() sendValue = new EventEmitter<any>();
  @Output() pressEnter = new EventEmitter<any>();

  listShow = [];

  reform;

  hasParentClass: boolean = false;

  maxElements: number = AppConstants.maxElementsInputWithSearch;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.active = typeof(this.active) == undefined ? true : this.active;
  }

  ngAfterViewInit(): void {
    const inputElement = this.el.nativeElement.querySelector('input');
    const grandParent = inputElement?.parentElement?.parentElement;

    if (grandParent && grandParent.classList.contains('selectorWidth')) {
      this.hasParentClass = true;
    }
  }

  focus$ = new Subject<string>();

  search: OperatorFunction<string, readonly string[]> = (
    text$: Observable<string>
  ) => {
    const debouncedText$ = text$.pipe(distinctUntilChanged());
    const inputFocus$ = this.focus$;
    return merge(debouncedText$, inputFocus$).pipe(
      map((term) =>
        (term.length < 2
          ? this.list
          : this.list?.filter(
              (v) =>
                v[this.id]?.toLowerCase().indexOf(term.toLowerCase()) > -1 ||
                (this.fields.length > 1
                  ? v[this.fields[1]]
                      ?.toLowerCase()
                      .indexOf(term.toLowerCase()) > -1
                  : false)
            )
        )?.slice(0, this.maxElements)
      )
    );
  };

  selectedItem(value) {
    value["id"] = this.id;
    this.sendValue.emit(value);
  }

  public onFocus(e: Event): void {
    e.stopPropagation();
    setTimeout(() => {
      const inputEvent: Event = new Event("input");
      e.target.dispatchEvent(inputEvent);
    }, 0);
  }

  public onClick(e: Event): void {
    this.item = null;
    let value = {
      id: this.id,
      item: undefined,
    };
    this.onFocus(e);
  }

  onFocusOut(e: Event): void {
    e.stopPropagation();
    let itemValue = {};
    this.fields.forEach((element, index) => {
      itemValue[element] = e.target["value"].split(" - ")[index];
    });
    itemValue = this.list.find(
      (e) => e[this.fields[0]] == itemValue[this.fields[0]]
    );
    let value = {
      id: this.id,
      item: itemValue,
    };

    this.sendValue.emit(value);
  }

  formatter = (x) => {
    if (x[this.fields[0]] != undefined) {
      if (this.fields.length == 1 && x[this.fields[0]] != "") {
        return x[this.fields[0]];
      } else if (
        this.fields.length == 2 &&
        x[this.fields[0]] != "" &&
        x[this.fields[1]] != ""
      ) {
        if (typeof x[this.fields[1]] === "undefined") {
          return x[this.fields[0]] + " - " + x["descripcion"];
        } else {
          return x[this.fields[0]] + " - " + x[this.fields[1]];
        }
      }
    }
  };

  onEnter(event: NgbTypeaheadSelectItemEvent) {
    this.pressEnter.emit("search");
  }
}
